export const PARENT_CATEGORY_LABELS = {
  finishing: "Finishing Projects",
  grey_structure: "Grey Structure Projects",
};

export const getParentCategoryKind = (category, categories = []) => {
  const name = String(category?.name || "").toLowerCase();
  if (name.includes("grey")) return "grey_structure";
  if (name.includes("finishing")) return "finishing";

  const sorted = [...categories].sort((a, b) => Number(a.id) - Number(b.id));
  const index = sorted.findIndex(
    (item) => String(item.id) === String(category?.id),
  );
  if (index === 0) return "finishing";
  if (index === 1) return "grey_structure";
  return null;
};

export const getParentCategoryLabel = (category, categories = []) => {
  const kind = getParentCategoryKind(category, categories);
  return (kind && PARENT_CATEGORY_LABELS[kind]) || category?.name || "—";
};

export const getFinishingParentCategory = (categories = []) => {
  const sorted = [...categories].sort((a, b) => Number(a.id) - Number(b.id));
  return (
    sorted.find(
      (category) => getParentCategoryKind(category, categories) === "finishing",
    ) ||
    sorted[0] ||
    null
  );
};

export const getFinishingParentCategoryId = (categories = []) => {
  const category = getFinishingParentCategory(categories);
  return category?.id != null ? String(category.id) : "";
};
